import React from 'react'
import classes from './layout.css'

const Checkbox = (props) => (
	<span>
		<input
			defaultChecked={props.value}
			id={props.id}
			className={classes.Checkbox}
			type="checkbox"
			name={props.name}
			onChange={(e) => props.controlFunc(e.target.name, e.target.checked, e.target.id)}
		/>
	</span>
)

export default Checkbox


// WEBPACK FOOTER //
// ./src/components/Fields/Checkbox.js